import { JenisTag, NewReplyBadge } from "@/components/admin/JenisTag";
import { MediaThumbs } from "@/components/admin/MediaThumbs";
import { StatusSelect } from "@/components/admin/StatusSelect";
import { formatDateID, formatPhone } from "@/lib/format";

export const ComplaintCards = ({ complaints, onStatusChange, updatingId, onOpenMedia, onOpenDetail }) => (
  <ul className="divide-y divide-slate-100" data-testid="complaints-cards">
    {complaints.map((c) => (
      <li key={c.id} className="space-y-3 p-4" data-testid={`complaint-row-${c.id}`}>
        <div>
          <p className="font-mono text-xs font-semibold text-slate-500" data-testid={`complaint-ticket-${c.id}`}>#{c.ticket} · {formatDateID(c.tanggal)}</p>
          <p className="mt-0.5 font-semibold text-slate-900">{c.nama}{c.has_new_reply && <NewReplyBadge id={c.id} />}</p>
          {c.nomor_hp && <p className="text-xs text-slate-500">{formatPhone(c.nomor_hp)}</p>}
          <p className="text-sm text-slate-500">{c.alamat}</p>
        </div>
        <JenisTag jenis={c.jenis} />
        <p className="line-clamp-3 text-sm text-slate-600">{c.detail}</p>
        <div className="flex items-center justify-between gap-3">
          <MediaThumbs attachments={c.attachments} onOpen={onOpenMedia} ownerId={c.id} />
          <button type="button" onClick={() => onOpenDetail(c)} className="text-xs font-semibold text-emerald-700" data-testid={`detail-btn-${c.id}`}>
            Lihat detail
          </button>
        </div>
        <StatusSelect complaint={c} onChange={onStatusChange} disabled={updatingId === c.id} />
      </li>
    ))}
  </ul>
);
